var TorsoFormView = require('backbone-torso/modules/FormView');
var selectVisitTypeTemplate = require('./eregPlaceholderAppointmentFormTemplate.hbs');
var DemographicsDataBehavior = require('./../../demographics/DemographicsDataBehavior');
var AppointmentTypeDataBehavior = require('./../../appointment-type/AppointmentTypeDataBehavior');

/**
 * View for rendering new appointment form, including selecting service and visit type.
 *
 * @class EregPlaceholderAppointmentFormView
 * @extends Torso.FormView
 */
module.exports = TorsoFormView.extend({
  className: 'appointment-form',
  template: selectVisitTypeTemplate,
  moduleNamespace: 'selectVisitTypeView',

  behaviors: {
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: '_patientVecnaId' }
    },
    serviceTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: function(cache) {
        return cache.fetchIdsByCriteria({levels: ['SERVICE']});
      }
    },
    selectedServiceType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: 'model:serviceLevelExternalId' }
    },
    visitTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      updateEvents:['view.model:change:serviceLevelExternalId'],
      ids: function(cache) {
        var parentExternalId = this.view.model.get('serviceLevelExternalId');
        if (parentExternalId) {
          return cache.fetchIdsByCriteria({parentExternalId: parentExternalId});
        }
      }
    }
  },

  feedback: [{
    when: {
      'on': ['validate'],
      '@serviceLevelVecnaId': ['change']
    },
    then: function() {
      return this._thenSetTextIfInvalid('serviceLevelExternalId', $.i18n.prop('eregStaffPlaceholderAppointmentEdit.error.noServiceType'));
    },
    to: 'serviceTypeError'
  }],

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentModel = options.appointmentModel;

    if (!this._appointmentModel) {
      throw ('appointmentModel is required to initialize EregPlaceholderAppointmentFormView');
    }

    this.set('DEFAULT_OPTION_VALUE', '');

    this.model.validation = {
      serviceLevelExternalId: {
        required: true
      }
    };

    //Clear out appointmentLevelExternalId when a new serviceLevelExternalId is selected.
    //Torso should do this when drawing the new visitType options, but doesn't as it only listens to DOM change events. Remove this when Torso bug #187 has been terminated
    var view = this;
    this.listenTo(this.model, 'change:serviceLevelExternalId', function() {
      view.model.set('appointmentLevelExternalId', null);
    });

    this.listenTo(this.model, 'change:serviceLevelExternalId change:appointmentLevelExternalId', this.setExternalIdOnAppointment);
  },

  /**
   * @method validate
   * Validate the form model, triggering when/thens for feedback
   * @returns {Object} errors object generated by backbone validation
   */
  validate: function() {
    this.trigger('validate');
    return this.model.validate();
  },

  /**
   * @method setExternalIdOnAppointment
   * Sets the externalId on the Appointment model using either the Appointment or Service level AppointmentType
   *
   */
  setExternalIdOnAppointment: function() {
    var visitTypeExternalId = this.model.get('appointmentLevelExternalId');
    var serviceTypeExteranlId = this.model.get('serviceLevelExternalId');
    var externalId;
    if (visitTypeExternalId) {
      externalId = this.getBehavior('visitTypes').data.privateCollection.get(visitTypeExternalId).get('externalId');
    } else if (serviceTypeExteranlId) {
      externalId = this.getBehavior('serviceTypes').data.privateCollection.get(serviceTypeExteranlId).get('externalId');
    }
    this._appointmentModel.set('externalAppointment.type', externalId);
  }
});
